import { gql, TypedDocumentNode } from "@apollo/client";
import { TrendingWatch, TrendingWatchCreateInput, TrendingWatchUpdateInput } from '../type/trending-watch'

export const FindTrendingWatch: TypedDocumentNode<{trendingWatchFind: TrendingWatch[]}> = gql`
    query FindTrendingWatch {
        trendingWatchFind {
            id
            item {
                id
                sku
                description
            }
            displayOrder
        }
    }
`

export const CreateTrendingWatch: TypedDocumentNode<void, {input: TrendingWatchCreateInput}> = gql`
    mutation CreateTrendingWatch ($input: TrendingWatchCreateInput!) {
        trendingWatchCreate(input: $input)
    }
`

export const UpdateTrendingWatch: TypedDocumentNode<void , {input: TrendingWatchUpdateInput[]}>= gql`
    mutation UpdateTrendingWatch ($input: [TrendingWatchUpdateInput !]!) {
        trendingWatchUpdate(input:$input)
    }
`

export const DeleteTrendingWatch: TypedDocumentNode<void, {id: number}> = gql`
    mutation DeleteTrendingWatch ($id: Int!) {
        trendingWatchDelete(id: $id)
    }
`
